export default __webpack_public_path__ + "static/larry-hyatt-transblue-baaf13a5a2cde3e337b0eb9b01478a2f.png";